import { darkTheme } from '../../Common/Themes/dark/dark'

const theme = {
  ...darkTheme,
  direction: 'ltr'
}

export default theme
